import PaperError from '@errors/PaperError';

export function resolveImagePath(relativePath: string): string {
    if (!window.bootstrapParams.imagesLocation.startsWith(window.location.origin)) {
        throw new PaperError('images folder should be located on the same host as the site itself');
    }

    let finalPath = window.bootstrapParams.imagesLocation;
    if (relativePath.startsWith('/')) {
        finalPath += relativePath;
    } else {
        finalPath += `/${relativePath}`;
    }

    return finalPath;
}
